<template>
  <div>
    <highcharts ref="chart" :options="chartOptions" />
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Object,
      default: function() {
        return {};
      },
    },
  },
  mounted() {
    setTimeout(() => {
      if (!this.$refs.chart) return;
      this.$refs.chart.chart.reflow();
    }, 200);
  },
  computed: {
    chartOptions() {
      return Object.assign({}, this.options, {
        credits: {
          enabled: false,
        },
        chart: {
          type: "area",
          height: 250,
        },
        title: {
          text: "",
        },
        yAxis: {
          min: 0,
          title: {
            text: "Cases",
          },
          stackLabels: {
            enabled: false,
          },
        },
        legend: {
          enabled: true,
        },
        tooltip: {
          shared: true,
          useHTML: true,
          formatter: function() {
            let points = this.points || [];
            let total = points.reduce(
              (sum, point) => sum + Number(point.y || 0),
              0
            );

            let rows = points
              .map(
                (point) =>
                  `<tr><td style="color:${point.series.color};padding:0">${point.series.name}: </td><td style="padding:0"><b>${Number(point.y || 0)}</b></td></tr>`
              )
              .join("");

            return (
              `<span style="font-size:10px">${this.x}</span><table>` +
              rows +
              `<tr><td style="padding-top:4px"><b>Total:</b></td><td style="padding-top:4px"><b>${total}</b></td></tr>` +
              "</table>"
            );
          },
        },
        plotOptions: {
          area: {
            stacking: "normal",
            lineWidth: 1,
            marker: {
              enabled: false,
            },
          },
        },
      });
    },
  },
};
</script>

<style scoped></style>
